<h3 class="modal-title">
  <span>Privacy Policy</span>
  <button *ngIf="data.closeable" mat-icon-button type="button"
  class="clear-btn"
          (click)="closeModal()"
          [matTooltip]="'common.buttons.close' | translate">
    <mat-icon>close</mat-icon>
  </button>
</h3>
<div class="modal-content" *ngIf="model$">
  <div class="data-protection" [innerHtml]="model$ | async"></div>
  <ng-container *ngIf="!data.closeable">
    <form #form="ngForm" (ngSubmit)="accepted && acceptGdpr()">
      <div class="separator"></div>
      <app-form-group>
        <mat-slide-toggle [(ngModel)]="accepted" id="agreeToPolicy" name="agreeToPolicy">
          <span>{{'dataProtectionPolicy.agreeToPolicy' | translate}}</span>
        </mat-slide-toggle>
      </app-form-group>

      <div class="buttons-bar">
        <button mat-button class="btn-primary" type="submit" [disabled]="!accepted">{{'common.buttons.accept' | translate | titlecase}}</button>
        <button mat-button class="btn-reset" type="button" (click)="rejectGdpr()">{{'common.buttons.cancel' | translate | titlecase}}</button>
      </div>
    </form>
  </ng-container>
</div>
